export default from './ModalMessage';



// WEBPACK FOOTER //
// ./src/elements/modal-message/index.jsx